import React from 'react';
import { AtSignIcon, LockKeyholeIcon, MailIcon, ShieldCheckIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton, SUPPORT_EMAIL, Section, WHATSAPP_LABEL, WHATSAPP_URL } from './Shared';
import { KanjiBackdrop, Mandala, Seal } from './Ornaments';
const contactLinkClass = 'inline-flex items-center gap-1.5 font-semibold text-emerald-700 underline-offset-2 hover:underline';
export function EmotionalClose() {
  return <Section className="max-w-4xl" data-id="element-14" data-mp="mmg4t6qeqhid">
      <div className="relative overflow-hidden rounded-2xl border border-stone-200 bg-white p-7 text-center shadow-lg md:p-12" data-id="element-15" data-mp="mjbs1kyvmdg3">
        <KanjiBackdrop glyphs={['選', '擇', '今', '始', '道']} data-id="element-16" data-mp="cmyz4pb5o3me" />
        <Mandala className="absolute -right-20 -top-20 h-64 w-64 opacity-10" color="#b45309" data-id="element-17" data-mp="cpl72q1ykl55" />
        <Mandala className="absolute -bottom-24 -left-24 h-64 w-64 opacity-10" color="#047857" data-id="element-18" data-mp="7q8nqfaapw7b" />
        <div className="relative" data-id="element-19" data-mp="270qfs8rwjnrc">
          <h2 className="text-3xl font-bold tracking-tight text-stone-900 md:text-5xl" data-id="element-20" data-mp="222onqyci0e3q">
            La próxima etapa de tu formación puede empezar hoy
          </h2>
          <div className="mx-auto mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-stone-700 md:text-lg" data-id="element-21" data-mp="354lty1kwb5bi">
            <p data-id="element-22" data-mp="39z9ane9nqvfj">
              La formación en Medicina China es un camino continuo. Siempre hay
              conceptos para revisar, ramas para explorar y nuevas relaciones para
              estudiar.
            </p>
            <p className="font-semibold text-emerald-700" data-id="element-23" data-mp="3ntacigvwoyk4">
              El KIT MEDICINA TRADICIONAL CHINA™ reúne seis tomos y tres bonus en
              una biblioteca visual para acompañar ese recorrido.
            </p>
            <p className="text-xl italic text-amber-800" data-id="element-24" data-mp="3e3z1uptdflu4">
              Hay dos opciones: seguir buscando cada tema en fuentes dispersas o
              reunir distintos materiales de estudio en un solo lugar.
            </p>
          </div>
          <div className="mx-auto mt-10 flex max-w-md flex-col items-center" data-id="element-25" data-mp="akdyjitofthl">
            <CTAButton fullWidth className="px-4 py-3.5 text-sm" data-id="element-26" data-mp="ferxfv7jsir0">
              → QUIERO MI KIT MEDICINA TRADICIONAL CHINA™
            </CTAButton>
          </div>
          <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-stone-500 md:text-sm" data-id="element-27" data-mp="k9kygkvsx3sn">
            <span className="inline-flex items-center gap-1" data-id="element-28" data-mp="g7g57n99m96j">
              <LockKeyholeIcon className="h-4 w-4" aria-hidden="true" data-id="element-29" data-mp="b9eld040m5u0" />
              Pago seguro con Mercado Pago
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-30" data-mp="6alazgk0yuy2">
              <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-31" data-mp="1jlay2flzwrc" />
              Garantía de 7 días
            </span>
          </div>
          <div className="mt-8 flex items-start gap-4 rounded-xl border border-stone-200 bg-stone-50 p-5 text-left text-sm leading-relaxed text-stone-700" data-id="element-32" data-mp="3sqxu2n01yk9w">
            <Seal characters="問答" className="mt-0.5 text-[11px]" data-id="element-33" data-mp="3omhs2wtk7wzy" />
            <div data-id="element-34" data-mp="3joomo602z70q">
              <h3 className="font-bold uppercase tracking-[0.06em] text-stone-900" data-id="element-35" data-mp="3jraorq47cubk">
                ¿Tenés alguna duda?
              </h3>
              <p className="mt-1" data-id="element-36" data-mp="1u8m0an8hq8fj">
                Si querés consultar algo antes de comprar, escribinos. Te
                respondemos por nuestros canales de atención.
              </p>
              <div className="mt-3 flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:gap-x-5" data-id="element-37" data-mp="246jo59mfu37m">
                <a className={contactLinkClass} href={`mailto:${SUPPORT_EMAIL}`} data-id="element-38" data-mp="287lojts3clb6">
                  <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-39" data-mp="285izbbyriw7i" />
                  {SUPPORT_EMAIL}
                </a>
                <a className={contactLinkClass} href="https://instagram.com/lumen.akasha" data-id="element-40" data-mp="1ggfsppjel9rp">
                  <AtSignIcon className="h-4 w-4" aria-hidden="true" data-id="element-41" data-mp="1kij9mtoud6kd" />
                  Instagram: @lumen.akasha
                </a>
                <a className={contactLinkClass} href={WHATSAPP_URL} data-id="element-42" data-mp="1pa17v9zhct1n">
                  <SmartphoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-43" data-mp="srd1bpyyw2k0" />
                  WhatsApp: {WHATSAPP_LABEL}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}